import AbstractNetworkStatus from '../all/AbstractNetworkStatus';

class AndroidNetworkStatus extends AbstractNetworkStatus {
    constructor() {
        super();
    }
}

export default AndroidNetworkStatus;



// WEBPACK FOOTER //
// ./src/devices/android/NetworkStatus.js